// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderWrapper":"PageLoader_pageLoaderWrapper__oqTIJ","kf-page-loader-spin":"PageLoader_kf-page-loader-spin__x4oKB"};